// extracted by mini-css-extract-plugin
export default {"dialog":"NoShowOverPhone--dialog--f0a950","container":"NoShowOverPhone--container--b41d75","phone":"NoShowOverPhone--phone--6d760b"};